/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// Rumo MCP session binding — mint an account+scope-bound grant after a fresh
// WhatsApp 2FA code. See Api::V1::Profile::KaptionMcpGrantsController.
class KaptionMcpGrantAPI extends ApiClient {
  constructor() {
    super('profile/kaption_mcp_grant', { accountScoped: false });
  }

  // NOTICE: KAPTION-INTEGRATION - ai-connectors.CONSENT.1: works before 2FA
  getStatus() {
    return axios.get(`${this.url}/status`);
  }

  getScopes() {
    return axios.get(`${this.url}/scopes`);
  }

  requestCode() {
    return axios.post(`${this.url}/request_code`);
  }

  createGrant({
    accountId,
    accountIds,
    allAccounts,
    roles,
    scopes,
    code,
    oreq,
    clientName,
  }) {
    return axios.post(this.url, {
      account_id: accountId,
      account_ids: accountIds,
      all_accounts: allAccounts,
      roles,
      scopes,
      code,
      oreq,
      client_name: clientName,
    });
  }
}

export default new KaptionMcpGrantAPI();
